import { parseLicenseDate } from "@/utils/licenseExpiry";

export function isPaidLicense(license) {
  return !!license && Number(license.is_free) !== 1;
}

export function isLicenseCurrentlyActive(license, now) {
  if (!license) {
    return false;
  }

  if (Number(license.is_unlimited) === 1) {
    return true;
  }

  const status = String(
    license.status_label || license.license_status || ""
  ).toLowerCase();
  if (status && status !== "active") {
    return false;
  }

  const expiry = parseLicenseDate(license.license_masa_aktif);
  if (!expiry) {
    // Biarkan backend menjadi penentu akhir bila format tanggal tidak dikenali.
    return true;
  }

  const current = now instanceof Date ? now : new Date();
  const todayUtc = Date.UTC(
    current.getFullYear(),
    current.getMonth(),
    current.getDate()
  );
  const expiryUtc = Date.UTC(
    expiry.getUTCFullYear(),
    expiry.getUTCMonth(),
    expiry.getUTCDate()
  );

  return expiryUtc >= todayUtc;
}

export function isEligibleFarmLicense(license) {
  return isPaidLicense(license) && isLicenseCurrentlyActive(license);
}

export function getFarmLicenseStatusLabel(license) {
  if (!license) {
    return "";
  }
  if (Number(license.is_unlimited) === 1) {
    return "Unlimited";
  }
  return "Berbayar aktif";
}

export function getFarmHeaderStatus(row) {
  const responseStatus = Number(row && row.first_response_is_success);
  const totalContact = Number(row && row.total_contact) || 0;

  if (responseStatus === 1) {
    return {
      key: "failed",
      label: "Gagal",
      tone: "danger",
      description: "Pencarian awal ke Google Maps gagal."
    };
  }

  if (responseStatus === 2 || totalContact > 0) {
    return {
      key: "done",
      label: "Selesai",
      tone: "success",
      description:
        "Pencarian awal berhasil. Jumlah kontak dapat bertambah selama detail masih diproses."
    };
  }

  return {
    key: "waiting",
    label: "Menunggu",
    tone: "warning",
    description: "Pencarian awal masih menunggu diproses."
  };
}

export function parseGmapLocation(value) {
  if (!value) {
    return null;
  }

  try {
    const parsed = typeof value === "string" ? JSON.parse(value) : value;
    const lat = Number(parsed && parsed.lat);
    const lng = Number(parsed && parsed.lng);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return null;
    }
    return { lat: lat, lng: lng };
  } catch (error) {
    return null;
  }
}

export function getGmapLocationUrl(value) {
  const location = parseGmapLocation(value);
  if (!location) {
    return "";
  }
  return (
    "https://www.google.com/maps/search/?api=1&query=" +
    location.lat +
    "," +
    location.lng
  );
}

export function getGmapLocationLabel(value) {
  const location = parseGmapLocation(value);
  if (!location) {
    return "";
  }
  return (
    location.lat.toFixed(5) + ", " + location.lng.toFixed(5)
  );
}

export function getApiErrorMessage(error, fallback) {
  if (
    error &&
    error.response &&
    error.response.data &&
    (error.response.data.msg || error.response.data.message)
  ) {
    return String(error.response.data.msg || error.response.data.message).replace(
      /<br\s*\/?>/gi,
      " "
    );
  }
  return fallback;
}



// WEBPACK FOOTER //
// ./src/utils/gmapContact.js